import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { IConnectRepository } from 'app/connect/core/IConnectRepository';
import { IConnectRepositoryFolder } from 'app/connect/core/IConnectRepositoryFolder';
import { ConnectEcmService } from 'app/connect/core/connect-ecm.service';

@Component({
  selector: 'connect-ecm-folders-list',
  templateUrl: 'connect-ecm-folders-list.component.html',
  styleUrls: ['connect-ecm-folders-list.component.scss']
})
export class ConnectEcmFoldersListComponent {

  @Input() foldersAvailable: any;
  @Input() selectedRepository: IConnectRepository;
  @Input() isChild: boolean;
  @Input() marginRightRadio = 4;
  @Output() onShowLoadingNodes: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedFolder: IConnectRepositoryFolder;
  @Input() parentName: string;
  public selectedFolderId: string;
  public foldersChildren: any[]

  constructor(private _connectEcmService: ConnectEcmService) {
  }

  async getFolderChild(folder) {
    this.onShowLoadingNodes.emit(true);
    // this.selectFolder(folder);
    this.foldersChildren = null;
    this.selectedFolderId = folder.Id;
    this.foldersChildren = await this._connectEcmService.getConnectionFolders(
      this.selectedRepository.environment.params.externalId,
      this.selectedRepository.environment.params, folder.Id
    );
    this.onShowLoadingNodes.emit(false);
  }

  onShowLoadingNodesEvent(event) {
    this.onShowLoadingNodes.emit(event);
  }

  selectFolder(folder) {
    this.selectedFolder.environment.params.externalId = folder.Id;
    this.selectedFolder.environment.params.path = folder.path;
  }

  assignPathToFolder(folder) {
    folder.path = `${this.parentName}\\${folder.Value}`;
  }
}
